//https://codeburst.io/react-router-v4-unofficial-migration-guide-5a370b8905a
// in src/restricted.js
import React, { Component } from 'react';
//import { withRouter } from 'react-router-dom';
//import checkCredentials from '../checkCredentials';
import frameworkStore from '../stores/frameworkStore';

/**
 * Higher-order component (HOC) to wrap restricted pages
 */
export var Restricted = BaseComponent =>  class extends Component {
		componentWillMount() {
			this.checkAuthentication(this.props);
		}
		componentWillReceiveProps(nextProps) {
			if (nextProps.location !== this.props.location) {
				this.checkAuthentication(nextProps);
			}
		}
		checkAuthentication(params) {			
			const { history } = params;
			
			if (!frameworkStore.isLoggedIn()) {
				history.replace({ pathname: '/login' });
			}				
		}
		render() {
			var base = <BaseComponent {...this.props} />;
			return base;
		}
	}


// WEBPACK FOOTER //
// ./src/components/restricted.js